import * as React  from 'react';


export  default  class  Loader extends React.Component {
   render(){
       return(                
            <div className="loader">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
            </div>
        );
    }
}